document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("common-product-showcase")) {
    class CommonProductShowcase extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.getAttribute("section-id") || "";
        this.sets = {
          enable_pin: this.getAttribute("data-enable_pin") === "true",
          disabled_pin_mb: this.getAttribute("data-disabled_pin_mb") === "true",
          swiper_pc_obj: this.querySelector(
            ".common-p-showcase-container-pc .swiper"
          ),
          swiper_m_obj: this.querySelector(
            ".common-p-showcase-container-mb .swiper"
          ),
          enable_swiper: this.getAttribute("data-enable_swiper") === "true",
          disabled_swiper_mb:
            this.getAttribute("data-disabled_swiper_mb") === "true",
          enable_swiper_mb:
            this.getAttribute("data-enable_swiper_mb") === "true",
          swiper_pc_num: this.getAttribute("data-swiper_pc_num"),
          swiper_pc_gap: this.getAttribute("data-swiper_pc_gap"),
          swiper_ipad_num: this.getAttribute("data-swiper_ipad_num"),
          swiper_mb_num: this.getAttribute("data-swiper_mb_num"),
          enable_arrow: this.getAttribute("data-enable_arrow") === "true",
          enable_pagination:
            this.getAttribute("data-enable_pagination") === "true",
          enable_scrollbar:
            this.getAttribute("data-enable_scrollbar") === "true",
          enable_auto_swiper:
            this.getAttribute("data-enable_auto_swiper") === "true",
          enable_auto_swiper_time: this.getAttribute(
            "data-enable_auto_swiper_time"
          ),
          enable_swiper_loop:
            this.getAttribute("data-enable_swiper_loop") === "true",
          blocks_size: this.getAttribute("data-blocks_size")
            ? parseInt(this.getAttribute("data-blocks_size"), 10)
            : 1,
          change_slide_event:
            this.getAttribute("data-change_slide_event") || "", // 直接 eval(changeSlideEvent) 或 new Function(changeSlideEvent) 使用
          every_day_decreasequantity:
            this.getAttribute("data-every_day_decreasequantity") === "true",
          custom_html_box: this.getAttribute("data-custom_html_box") === "true",
          change_slide_classname: this.getAttribute(
            "data-change_slide_classname"
          ),
          swiper_pc_rows_num: this.getAttribute("data-swiper_pc_rows_num")
            ? parseInt(this.getAttribute("data-swiper_pc_rows_num"), 10)
            : 0,
          swiper_ipad_rows_num: this.getAttribute("data-swiper_ipad_rows_num")
            ? parseInt(this.getAttribute("data-swiper_ipad_rows_num"), 10)
            : 0,
          swiper_m_rows_num: this.getAttribute("data-swiper_m_rows_num")
            ? parseInt(this.getAttribute("data-swiper_m_rows_num"), 10)
            : 0,
          swiper_direction: this.getAttribute("data-swiper_direction"),
          variant_obj: this.querySelectorAll(".product-variant-img"),
          product_swiper_filter: this.getAttribute(
            "data-product_swiper_filter_settings"
          ),
          swiperPCConfig: {},
          enable_separate_cart_button:
            this.getAttribute("data-enable_separate_cart_button") === "true",
          enable_quantity_discount:
            this.getAttribute("data-enable_quantity_discount") === "true",
        };
        this.parentObj = null;
        this.mySwiper = null;
      }

      connectedCallback() {
        this.detectObserver();
      }
      detectObserver() {
        let height = window.innerHeight * 2;
        const container = this.querySelector(".common-p-showcase-section");
        if (container) {
          const resizeObserver = new IntersectionObserver(
            ([entry]) => {
              if (entry.isIntersecting) {
                this.parentObj = this.querySelector(
                  `.common-p-showcase-section`
                );
                this.initSwiper();
                this.initPin();
                this.initInventory();
                this.initImgShowcaseSwiper();
                this.initMultiProduct();
                this.initResize();
                this.initSlideClassname();
                this.initVariantEvent();
                this.initSwiperFilter();
                resizeObserver.disconnect();
              }
            },
            { threshold: 0, rootMargin: `${height}px 0px 0px 0px` }
          );
          resizeObserver.observe(container);
        }
      }
      initSwiper() {
        const set = this.sets;
        if (!set) return;

        const isMobile = window.innerWidth <= 850;
        if (!set.enable_swiper && !set.enable_swiper_mb) return;
        let slidesPerColumn = 1,
          slidesPerColumnPC = 1,
          slidesPerColumnIpad = 1;
        slidesPerColumnPC = parseInt(set.swiper_pc_rows_num);
        slidesPerColumnIpad = slidesPerColumnPC;
        if (
          $(window).width() <= 1024 &&
          set.swiper_ipad_rows_num > 0 &&
          set.swiper_ipad_rows_num < set.blocks_size
        ) {
          slidesPerColumnIpad = set.swiper_ipad_rows_num;
        }
        if (
          $(window).width() <= 589 &&
          set.swiper_m_rows_num > 0 &&
          set.swiper_m_rows_num < set.blocks_size
        ) {
          slidesPerColumn = parseInt(set.swiper_m_rows_num);
        }
        // PC端轮播
        if (set.enable_swiper) {
          const swiperPCConfig = {
            slidesPerView: set.swiper_pc_num || 1,
            spaceBetween: +set.swiper_pc_gap || 20,
            autoHeight: this.parentObj?.dataset.autoheight === "true",
            loop: !!set.enable_swiper_loop,
            slidesPerColumn: slidesPerColumnPC,
            slidesPerColumnFill: set.swiper_direction,
            navigation: {},
            pagination: {},
            breakpoints: {
              1024: {
                slidesPerView: set.swiper_ipad_num || set.swiper_pc_num || 1,
                spaceBetween: 15,
                slidesPerColumn: slidesPerColumnIpad,
              },
              589: {
                slidesPerView: set.swiper_mb_num || 1,
                spaceBetween: 10,
                slidesPerColumn: slidesPerColumn,
              },
            },
            on: {
              slideChangeTransitionEnd: function () {
                let index = this.activeIndex;
                if (
                  set.change_slide_event &&
                  typeof set.change_slide_event === "string"
                ) {
                  try {
                    eval(set.change_slide_event);
                  } catch (e) {
                    console.error("轮播切换事件执行失败:", e);
                  }
                }
              },
            },
          };

          // 箭头导航
          if (set.enable_arrow) {
            const nextBtn = this.querySelector(
              ".common-p-showcase-container-pc .swiper-button-next"
            );
            const prevBtn = this.querySelector(
              ".common-p-showcase-container-pc .swiper-button-prev"
            );
            if (nextBtn && prevBtn) {
              swiperPCConfig.navigation = {
                nextEl: nextBtn,
                prevEl: prevBtn,
              };
            }
          }

          // 分页
          if (set.enable_pagination) {
            const paginationEl = this.querySelector(
              ".common-p-showcase-container-pc .swiper-pagination"
            );
            if (paginationEl) {
              swiperPCConfig.pagination = {
                el: paginationEl,
                clickable: true,
              };
            }
          }

          // 滚动条
          if (set.enable_scrollbar) {
            const scrollbarEl = this.querySelector(
              ".common-p-showcase-container-pc .swiper-scrollbar"
            );
            if (scrollbarEl) {
              swiperPCConfig.scrollbar = { el: scrollbarEl, draggable: true };
            }
          }

          // 自动播放
          if (set.enable_auto_swiper) {
            swiperPCConfig.autoplay = {
              delay: parseInt(set.enable_auto_swiper_time) || 3000, // 数字类型+兜底
              stopOnLastSlide: false,
              disableOnInteraction: true,
            };
          }
          this.mySwiper = new Swiper(set.swiper_pc_obj, swiperPCConfig);
          this.sets.swiperPCConfig = swiperPCConfig;
        }

        if (set.enable_swiper_mb && isMobile) {
          const swiperMBConfig = {
            slidesPerView: +set.swiper_ipad_num || 1,
            spaceBetween: 15,
            navigation: {},
            pagination: {},
            breakpoints: {
              589: {
                slidesPerView: +set.swiper_mb_num || 1,
                spaceBetween: 10,
              },
            },
            on: {},
          };

          if (set.enable_arrow) {
            const nextBtn = this.querySelector(
              ".common-p-showcase-container-mb .swiper-button-next"
            );
            const prevBtn = this.querySelector(
              ".common-p-showcase-container-mb .swiper-button-prev"
            );
            if (nextBtn && prevBtn) {
              swiperMBConfig.navigation = {
                nextEl: nextBtn,
                prevEl: prevBtn,
              };
            }
          }

          if (set.enable_pagination) {
            const paginationEl = this.querySelector(
              ".common-p-showcase-container-mb .swiper-pagination"
            );
            if (paginationEl) {
              swiperMBConfig.pagination = {
                el: paginationEl,
                clickable: true,
              };
            }
          }

          if (set.enable_scrollbar) {
            const scrollbarEl = this.querySelector(
              ".common-p-showcase-container-mb .swiper-scrollbar"
            );
            if (scrollbarEl) {
              swiperMBConfig.scrollbar = { el: scrollbarEl, draggable: true };
            }
          }

          this.mySwiper = new Swiper(set.swiper_m_obj, swiperMBConfig);
        }

        if (set.disabled_swiper_mb && isMobile && this.mySwiper) {
          this.mySwiper.destroy(true);
          this.mySwiper = null;
        }
      }

      initPin() {
        const set = this.sets;

        if (!set.enable_pin) return;
        if (disabled_pin_mb && window.innerWidth <= 850) {
          return;
        }
        const pin_container = this.querySelector(".pin-container");
        let distanceHeightSwiper =
          Math.floor(
            window.innerHeight / 2 -
              this.parentObj.querySelector(".custom-product-content")
                .offsetHeight /
                2
          ) + 60;
        distanceHeightSwiper =
          distanceHeightSwiper > 60 ? distanceHeightSwiper : 60;
        let triggerStr = `0 ${distanceHeightSwiper}`;
        if (window.innerWidth < 850) triggerStr = `0 40`;
        let tl = gsap.timeline();
        for (let i = 1; i <= set.blocks_size; i++) {
          tl.add(this.showcaseSwiperItem(i));
        }
        const scrollHeight = window.innerHeight * (set.blocks_size - 1);
        ScrollTrigger.create({
          trigger: pin_container,
          start: triggerStr,
          end: "+=" + scrollHeight,
          scrub: true,
          pin: true,
          animation: tl,
        });
      }

      showcaseSwiperItem(index) {
        return gsap
          .timeline()
          .addLabel(`common-p-showcase-section-${this.sectionId}-${index}`)
          .to(`.common-p-showcase-section-${this.sectionId}`, 0.01, {
            onUpdate: () => {
              this.mySwiper?.slideTo(index - 1);
            },
          });
      }

      initInventory() {
        const set = this.sets;
        if (!set.every_day_decreasequantity) return;
        const nowtime = new Date();
        const temp =
          (new Date().getTimezoneOffset() / -60 - 8) * 60 * 60 * 1000;
        this.querySelectorAll(".inventory-container").forEach((container) => {
          const startDate = new Date(container.dataset.caculate_time);
          let milliseconds =
            nowtime.getTime() - startDate.getTime() < 0
              ? 0
              : nowtime.getTime() - startDate.getTime() + temp;
          let tDiffDays = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
          tDiffDays =
            tDiffDays / 2 > 0.5 ? Math.ceil(tDiffDays) : Math.floor(tDiffDays);
          const qty = container.dataset.orgin_quantity;
          const decreaseQty = container.dataset.decrease_quantity;
          const qtyDays = decreaseQty * tDiffDays;
          const diff = qty - qtyDays > 0 ? qty - qtyDays : 0;
          const saleDiff = 100 - (qtyDays / qty) * 100;
          container.querySelector(".num_qty").textContent = diff;
          container.querySelector(".first").style.width = saleDiff + "%";
          container.querySelector(".after").style.left = saleDiff - 1 + "%";
        });
      }

      initImgShowcaseSwiper() {
        this.querySelectorAll(".img-showcase-swiper").forEach((swiperEl) => {
          const id = swiperEl.dataset.id;
          new Swiper(`.img-showcase-swiper-${id}`, {
            slidesPerView: 1,
            navigation: {
              nextEl: `.img-showcase-swiper-${id} .swiper-button-next`,
              prevEl: `.img-showcase-swiper-${id} .swiper-button-prev`,
            },
          });
        });
      }

      initMultiProduct() {
        const set = this.sets;
        if (!set.custom_html_box) return;
        const sectionContainer = this;
        const multiAddBtn = sectionContainer.querySelector(
          ".change-showcase-container multi-add-cart-button"
        );
        const commonBuyBtn = sectionContainer.querySelector(
          ".change-showcase-container .showcase-buy-now"
        );
        const commonAddCartBtn = sectionContainer.querySelector(
          ".change-showcase-container .common-add-cart"
        );

        const contentContainer = sectionContainer.querySelector(".content");
        if (contentContainer) {
          contentContainer.addEventListener("click", function (e) {
            const learnMoreLink = e.target.closest(".learn_more_btn a");
            if (learnMoreLink) {
              e.stopPropagation(); 
            }
          });
        }
        if (!multiAddBtn) return;

        const updateSelectedProductsList = () => {
          const selectedItems = sectionContainer.querySelectorAll(
            ".custom-item.showcase-active"
          );
          const chooseProductList = sectionContainer.querySelector(
            ".choose-product-box .choose-product-list"
          );
          if (!chooseProductList) return;

          // 清空列表
          chooseProductList.innerHTML = "";

          // 为每个选中的产品创建卡片
          selectedItems.forEach((item) => {
            // 获取唯一的 block 标识：优先使用 swiper-slide-{index}，如果没有则使用 showcase-item-{blockId}
            let blockIdentifier = "";
            const classList = Array.from(item.classList);
            
            // 查找 swiper-slide-{index} 类
            const swiperSlideClass = classList.find(cls => cls.startsWith("swiper-slide-") && cls !== "swiper-slide");
            if (swiperSlideClass) {
              blockIdentifier = swiperSlideClass; // 例如: swiper-slide-1
            } else {
              // 如果没有 swiper-slide-{index}，使用 showcase-item-{blockId}
              const showcaseItemClass = classList.find(cls => cls.startsWith("showcase-item-"));
              if (showcaseItemClass) {
                blockIdentifier = showcaseItemClass; // 例如: showcase-item-block_QEBY8U
              }
            }
            
            if (!blockIdentifier) {
              console.warn("无法找到 block 的唯一标识", item);
              return;
            }

            // 获取 block 的 title_title（从 .common-title.title-box a 中）
            const titleTitleEl = item.querySelector(".common-title.title-box a");
            const titleTitle = titleTitleEl
              ? titleTitleEl.textContent.trim()
              : "";

            // 如果没有 title_title，尝试获取普通标题
            const productTitle = titleTitle || 
              (item.querySelector(".common-title.title-box")?.textContent.trim() || "Product");

            // 获取产品价格（现价）
            const salePriceEl = item.querySelector(".on-sale");
            const salePrice = salePriceEl
              ? parseFloat(salePriceEl.getAttribute("content")) || 0
              : 0;
            const formattedPrice = salePrice
              ? window.theme.Currency.formatMoney(
                  salePrice * 100,
                  window.theme.strings.moneyFormat
                )
              : "";

            // 获取产品图片（从 .image 容器中查找第一个 img 标签）
            const imageContainer = item.querySelector(".image");
            let imageSrc = "";
            let imageAlt = "";
            if (imageContainer) {
              const imgEl = imageContainer.querySelector("img");
              if (imgEl) {
                imageSrc = imgEl.src || imgEl.getAttribute("src") || "";
                imageAlt = imgEl.alt || productTitle;
              }
            }

            // 创建产品卡片
            const productCard = document.createElement("div");
            productCard.className = "choose-product-item";
            productCard.setAttribute("data-block-identifier", blockIdentifier);
            
            // 构建 HTML，左边是图片，右边是 title + 价格
            const imageHtml = imageSrc
              ? `<div class="choose-product-image">
                   <img src="${imageSrc}" alt="${imageAlt}" />
                 </div>`
              : "";
            
            productCard.innerHTML = `
              ${imageHtml}
              <div class="choose-product-info">
                <span class="choose-product-name">${productTitle}</span>
                <span class="choose-product-price">${formattedPrice}</span>
              </div>
              <button class="choose-product-remove" aria-label="Remove product">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                </svg>
              </button>
            `;

            // 添加删除按钮点击事件
            const removeBtn = productCard.querySelector(".choose-product-remove");
            removeBtn.addEventListener("click", (e) => {
              e.stopPropagation();
              // 使用 block 唯一标识来找到对应的产品卡片并移除 showcase-active 状态
              const targetItem = sectionContainer.querySelector(
                `.custom-item.${blockIdentifier}`
              );
              if (targetItem) {
                targetItem.classList.remove("showcase-active");
                updateMultiProductState();
              } else {
                console.warn("无法找到对应的 block:", blockIdentifier);
              }
            });

            chooseProductList.appendChild(productCard);
          });
        };

        const updateMultiProductState = () => {
          const selectedProducts = getSelectedProducts();
          multiAddBtn.setAttribute(
            "data-products",
            JSON.stringify(
              selectedProducts.map((p) => ({
                variantId: p.variantId,
                quantity: p.quantity,
              }))
            )
          );

          let totalSalePrice =
            selectedProducts.reduce((sum, p) => sum + p.salePrice, 0) * 100;
          let totalComparePrice =
            selectedProducts.reduce((sum, p) => sum + p.comparePrice, 0) * 100;

          // 应用数量折扣（只对售价打折，原价保持不变）
          if (set.enable_quantity_discount && selectedProducts.length > 0) {
            const itemCount = selectedProducts.length;
            let discountMultiplier = 1;
            
            if (itemCount >= 3) {
              discountMultiplier = 0.7; // 3件及以上打7折
            } else if (itemCount >= 2) {
              discountMultiplier = 0.8; // 2件打8折
            }
            
            totalSalePrice = Math.round(totalSalePrice * discountMultiplier);
            // 原价不应用折扣，保持原样
          }

          const priceContainer = sectionContainer.querySelector(
            ".change-showcase-container .product-price-box"
          );
          if (priceContainer) {
            const salePriceEl = priceContainer.querySelector(".on-sale");
            const comparePriceEl = priceContainer.querySelector(".compare-at");

            if (salePriceEl) {
              salePriceEl.setAttribute("content", totalSalePrice);
              salePriceEl.textContent = window.theme.Currency.formatMoney(
                totalSalePrice,
                window.theme.strings.moneyFormat
              );
            }

            if (comparePriceEl) {
              comparePriceEl.setAttribute("content", totalComparePrice);
              comparePriceEl.textContent =
                totalSalePrice !== totalComparePrice
                  ? window.theme.Currency.formatMoney(
                      totalComparePrice,
                      window.theme.strings.moneyFormat
                    )
                  : "";
            }
          }

          // 更新选择产品列表
          updateSelectedProductsList();
        };
       const itemContainer = sectionContainer.querySelector(
          ".custom-item-container"
        );
        if (itemContainer) {
          itemContainer.addEventListener("click", function (e) {
            const targetItem = e.target.closest(".custom-item");
            if (targetItem) {
              targetItem.classList.toggle("showcase-active");

              updateMultiProductState();
            }
          });
        }

        function getSelectedProducts() {
          const selectedItems = sectionContainer.querySelectorAll(
            ".custom-item.showcase-active"
          );
          const products = [];
          selectedItems.forEach((item) => {
            const variantIdInput = item.querySelector("input[name='id']");
            const variantId = variantIdInput
              ? parseInt(variantIdInput.value, 10)
              : null;
            if (!variantId || isNaN(variantId)) return;

            const salePriceEl = item.querySelector(".on-sale");
            const comparePriceEl = item.querySelector(".compare-at");

            let salePrice = salePriceEl
              ? parseFloat(salePriceEl.getAttribute("content")) || 0
              : 0;
            let comparePrice = comparePriceEl
              ? parseFloat(comparePriceEl.getAttribute("content")) || 0
              : 0;

            if (comparePrice > 0 && salePrice > comparePrice) {
              [salePrice, comparePrice] = [comparePrice, salePrice];
            } else if (comparePrice === 0) {
              comparePrice = salePrice;
            }

            products.push({ variantId, quantity: 1, salePrice, comparePrice });
          });
          return products;
        }

        function triggerBtnEvent() {
          if (set.enable_separate_cart_button) {
            sectionContainer
              .querySelector(".change-showcase-container multi-add-cart-button")
              ?.click();
          }
        }
        if (commonBuyBtn) {
          commonBuyBtn.addEventListener("click", function (e) {
            multiAddBtn.setAttribute("data-type", "checkout");
            triggerBtnEvent();
          });
        }
        if (commonAddCartBtn) {
          commonAddCartBtn.addEventListener("click", function (e) {
            multiAddBtn.setAttribute("data-type", "cart");
            triggerBtnEvent();
          });
        }

        // 初始化时更新选择产品列表
        // 使用 setTimeout 确保 DOM 已完全渲染
        setTimeout(() => {
          updateSelectedProductsList();
        }, 0);
      }

      initResize() {
        window.addEventListener("resize", () => {
          this.mySwiper && this.mySwiper.update();
        });
      }

      initSlideClassname() {
        const set = this.sets;
        if (!set.change_slide_classname) return;
        document.querySelectorAll(set.change_slide_classname).forEach((el) => {
          el.addEventListener("click", () => {
            const index = el.dataset.index;
            el.classList.add("active");
            el.parentElement.querySelectorAll(".active").forEach((sib) => {
              if (sib !== el) sib.classList.remove("active");
            });
            this.mySwiper?.slideTo(index);
          });
        });
      }
      initVariantEvent() {
        const set = this.sets;
        if (!set.variant_obj || set.variant_obj.length === 0) return;
        set.variant_obj.forEach((variant_item) => {
          variant_item.addEventListener("click", () => {
            const variantId = variant_item.dataset.id;

            variant_item.classList.add("active");
            variant_item.parentElement
              .querySelectorAll(".product-variant-img")
              .forEach((sibling) => {
                if (sibling !== variant_item)
                  sibling.classList.remove("active");
              });

            const quickBuyBtn = variant_item
              .closest(".content")
              ?.querySelector(".quick-buynow-btn");
            if (quickBuyBtn) {
              quickBuyBtn.setAttribute("data-id", variantId);
            }
            // 在这里改变父级的variantId
            const multiAddBtn = variant_item
              .closest(".common-p-showcase-section")
              ?.querySelector("multi-add-cart-button");
            if (multiAddBtn) {
              multiAddBtn.setAttribute(
                "data-products",
                JSON.stringify([{ variantId, quantity: 1 }])
              );
            }
          });
        });
      }
      initSwiperFilter() {
        const set = this.sets;
        if (!set.product_swiper_filter) return;

        const sectionContainer = this;
        const filterButtons = sectionContainer.querySelectorAll(
          ".filter-buttons .filter-btn"
        );
        const swiperWrapper = sectionContainer.querySelector(
          ".common-p-showcase-container-pc .custom-item-container"
        );
        let allSlides = !set.custom_html_box
          ? Array.from(swiperWrapper.querySelectorAll(".custom-item")).map(
              (slide) => slide.cloneNode(true)
            )
          : Array.from(swiperWrapper.querySelectorAll(".custom-item"));
        let applyFilter = () => {};
        const cacheContainer = document.createElement("div");
        cacheContainer.style.display = "none";
        sectionContainer.appendChild(cacheContainer);

        if (filterButtons.length === 0 || allSlides.length === 0) return;

        if (!set.custom_html_box) {
          const renderSlides = (slidesToRender) => {
            while (swiperWrapper.firstChild) {
              swiperWrapper.removeChild(swiperWrapper.firstChild);
            }
            slidesToRender.forEach((slide) => {
              swiperWrapper.appendChild(slide);
            });
            this.mySwiper?.update();
            this.mySwiper?.slideTo(0);
          };

          applyFilter = (filterValue) => {
            const filteredSlides = allSlides.filter((slide) => {
              const categoryStr = slide.getAttribute("data-category") || "";
              const categories = categoryStr
                .split(";")
                .map((c) => c.trim())
                .filter(Boolean);
              return filterValue === "all" || categories.includes(filterValue);
            });

            filterButtons.forEach((btn) => {
              btn.classList.toggle(
                "active",
                btn.getAttribute("data-filter") === filterValue
              );
            });

            renderSlides(filteredSlides);
          };
        } else {
          applyFilter = (filterValue) => {
            while (cacheContainer.firstChild) {
              swiperWrapper.appendChild(cacheContainer.firstChild);
            }

            filterButtons.forEach((btn) => {
              btn.classList.toggle(
                "active",
                btn.getAttribute("data-filter") === filterValue
              );
            });

            allSlides.forEach((slide) => {
              const categoryStr = slide.getAttribute("data-category") || "";
              const categories = categoryStr
                .split(";")
                .map((c) => c.trim())
                .filter(Boolean);

              const isVisible =
                filterValue === "all" || categories.includes(filterValue);

              if (!isVisible) {
                cacheContainer.appendChild(slide);
              }
            });

            this.mySwiper?.update();
            this.mySwiper?.slideTo(0);
          };
        }

        filterButtons.forEach((button) => {
          button.addEventListener("click", () => {
            const filter = button.getAttribute("data-filter");
            sectionContainer
              .querySelector(".common-p-showcase")
              .setAttribute("data-filter-name", filter);
            applyFilter(filter);
          });
        });

        if (!set.custom_html_box) {
          if (filterButtons.length > 0) {
            setTimeout(() => {
              const defaultFilter =
                filterButtons[0].getAttribute("data-filter");
              applyFilter(defaultFilter);
            }, 0);
          }
        }
        if (filterButtons.length > 0) {
          setTimeout(() => {
            const targetButton = Array.from(filterButtons).find(
              (btn) => btn.getAttribute("data-filter") === "bf-category1-2"
            );
            const defaultFilter = targetButton
              ? "bf-category1-2"
              : filterButtons[0].getAttribute("data-filter");

            applyFilter(defaultFilter);

            sectionContainer
              .querySelector(".common-p-showcase")
              .setAttribute("data-filter-name", defaultFilter);
          }, 0);
        }
      }
    }

    customElements.define("common-product-showcase", CommonProductShowcase);
  }
});
